<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>

        <subNav></subNav>
        <div class="pressReleases">
            <div class="wrap">
                <div class="title">REPORTS & FILINGS</div>
                <div class="rf-itemlist">
                    <!-- <div :class="cItem1"><span @click="changeItem(1)">SEC Filings</span></div>
                    <div :class="cItem2"><span @click="changeItem(2)">Annual/Interim Reports</span></div>
                    <div class="clear"></div> -->
                    <filingBox></filingBox>
                </div>
                <div class="press-content">
                    <div data-qmod-tool="filings" data-qmod-params='{"symbol":"MMV"}' class="qtool"></div>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
import filingBox from "@/components/filingBox/filingBox";
export default {
    name: "reportsFilings",
    components: { footerBox, navBox, subNav,mapBox, filingBox },
    data() {
        return {
            input: "",
            value3: "",
            group:"",
            loading:false,
        };
    },
    created(){
        this.getrReportsFilings({group_cn:this.group, keywords:this.input})
    },
    methods:{
    }
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.clear {
    clear: both;
}
//内容
.pressReleases {
    padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .rf-itemlist{
        width: 100%;
        height: 50px;
        padding: 0px 10px 10px 10px;
        text-align: center;
    }
    .rf-item{
        width: 20%;
        height: 100%;
        float: left;
        text-align: center;
        font-size: 20px;
        line-height: 30px;
    }
    .rf-item span{
        height: 40px;
        margin: auto;
        line-height: 40px;
        display: inline-block;
    }
    .active {
    }
    .active span {
        border-bottom: 2px #000000 solid;
    }
    
    .listItem {
        width: 45%;
        height: 50px;
        float: left;
        text-align: left;
    }

    .fileListBody {
        width: 48%;
        float: left;

        height: 145px;
        border-bottom: 1px solid #e9e9e9;
        span {
            display: inline-block;
        }
        .time {
            width: 150px;
            color: #333333;
            font-size: 14px;
            text-indent: 20px;
            height: 110px;
            line-height: 110px;
        }
        .num {
            width: 90px;
            height: 110px;
            line-height: 110px;
            color: #409EFF;
            font-family: 'Lucida Bright';
        }
        .michael {
            width: 165px;
            height: 145px;
            line-height: 145px;
            color: #333333;
            font-family: 'Lucida Bright';
        }
        .headline {
            color: #333333;
            font-size: 16px;
            width: 400px;
            height: 145px;;
            line-height: 30px;
            font-family: 'Lucida Bright';
        }
        .group {
            width: 155px;
            height: 145px;
            line-height: 145px;
            color: #333333;
            font-family: 'Lucida Bright';
        }
    }
    .fileItem {
        width: 100%;
        height: 80px;
        padding-top: 20px;
        .fileTypeIcon{
            width: 18%;
            float: left;
            height: 100%;
            .printer-pdf {
                img {
                    margin-left: 30px;
                    width: 22px;
                    height: 25px;
                }
            }
            padding: 10px 10px 0px 0px;
            line-height: 40px;
        }
        .fileTitle {
            width: 80%;
            float: left;
            height: 100%;
            line-height: 40px;
        }
    }
    .press-content {
        border: 1px solid #dcdcdc;
        padding: 10px;
        .news {
            margin-top: 15px;
            display: flex;
            .caption {
                margin-bottom: 10px;
            }
            .year {
                margin-left: 20px;
            }
            .filter {
                position: relative;
                top: 30px;
                margin-left: 30px;
            }
            .group {
                margin-left: 105px;
            }
        }
        .sub-caption {
            width: 1140px;
            height: 30px;
            line-height: 30px;
            color: #f2f2f2;
            font-size: 15px;
            background: #283254;
            margin-top: 45px;
            span {
                display: inline-block;
            }
            .date {
                width: 150px;
                text-indent: 20px;
            }
            .form {
                width: 90px;
            }
            .filer {
                width: 165px;
            }
            .description {
                width: 400px;
            }
            .Filing {
                width: 155px;
            }
            .view {
                width: 180px;
            }
        }
        .pagination{
            text-align: center;
        }
    }
}
.pressReleases .press-content ul li .headline label:hover {
    border-bottom: 2px solid #a5a5a5;
    cursor: pointer;
}
</style>